import { Check, Copy } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

const COPIED_FEEDBACK_MS = 1500;

/** Copies a message's text; shows a check mark briefly on success. */
export const CopyMessageButton: React.FC<{ text: string }> = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
    } catch {
      // clipboard blocked (insecure context or permission): nothing to show
    }
  };

  return (
    <button
      type="button"
      onClick={() => void copy()}
      title={copied ? 'Copied' : 'Copy message'}
      aria-label={copied ? 'Copied' : 'Copy message'}
      className="rounded p-1 text-slate-400 opacity-0 transition-opacity hover:bg-slate-200 hover:text-slate-600 focus:opacity-100 group-hover:opacity-100 dark:hover:bg-slate-600 dark:hover:text-slate-200"
    >
      {copied ? <Check size={14} className="text-green-500" /> : <Copy size={14} />}
    </button>
  );
};
